// extracted by mini-css-extract-plugin
export default {"wrapper":"CardIcon_wrapper__4a+dC","icon":"CardIcon_icon__ZJs9o","border":"CardIcon_border__IepWJ","has-color":"CardIcon_has-color__-1g0I"};